// booking.js

// Lucide icons
lucide.createIcons();

// Calendar logic
const calendarGrid = document.getElementById('calendarGrid');
const currentMonth = document.getElementById('currentMonth');
const prevMonthBtn = document.getElementById('prevMonth');
const nextMonthBtn = document.getElementById('nextMonth');
const dateInput = document.getElementById('date');

let today = new Date();
let selectedDate = null;
let month = today.getMonth();
let year = today.getFullYear();

function renderCalendar() {
  // Set month name
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  currentMonth.textContent = `${monthNames[month]} ${year}`;

  // Remove previous dates
  Array.from(calendarGrid.querySelectorAll('.calendar-date')).forEach(e => e.remove());

  // Get first day of month
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  // Add empty slots for days before first day
  for (let i = 0; i < firstDay; i++) {
    const empty = document.createElement('div');
    empty.className = 'calendar-date disabled';
    calendarGrid.appendChild(empty);
  }

  // Add days
  for (let d = 1; d <= daysInMonth; d++) {
    const dateDiv = document.createElement('div');
    dateDiv.className = 'calendar-date';
    dateDiv.textContent = d;

    const thisDate = new Date(year, month, d);
    if (
      thisDate < new Date(today.getFullYear(), today.getMonth(), today.getDate())
    ) {
      dateDiv.classList.add('disabled');
    } else {
      dateDiv.onclick = function () {
        selectedDate = thisDate;
        dateInput.value = thisDate.toISOString().slice(0, 10);
        Array.from(calendarGrid.querySelectorAll('.calendar-date')).forEach(e => e.classList.remove('active'));
        dateDiv.classList.add('active');
      };
    }
    calendarGrid.appendChild(dateDiv);
  }
}

prevMonthBtn.onclick = function () {
  if (month === 0) {
    month = 11;
    year--;
  } else {
    month--;
  }
  renderCalendar();
};

nextMonthBtn.onclick = function () {
  if (month === 11) {
    month = 0;
    year++;
  } else {
    month++;
  }
  renderCalendar();
};

renderCalendar();

// Service Tabs Logic
document.querySelectorAll('.tab-btn').forEach(btn => {
  btn.addEventListener('click', function() {
    document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
    document.querySelectorAll('.tab-content').forEach(tc => tc.classList.remove('active'));
    btn.classList.add('active');
    document.getElementById('tab-' + btn.dataset.tab).classList.add('active');
  });
});

function setupSubcats(tabPrefix) {
  const subcatBtns = document.querySelectorAll(`#${tabPrefix}-subcats .subcat-btn`);
  const subcatContents = document.querySelectorAll(`#tab-${tabPrefix} .subcat-content`);

  // Remove active from all buttons and contents
  subcatBtns.forEach(b => b.classList.remove('active'));
  subcatContents.forEach(c => c.classList.remove('active'));

  // Set first button and content as active
  if (subcatBtns.length && subcatContents.length) {
    subcatBtns[0].classList.add('active');
    subcatContents[0].classList.add('active');
  }

  // Add click listeners (remove previous ones first)
  subcatBtns.forEach(btn => {
    btn.onclick = function() {
      subcatBtns.forEach(b => b.classList.remove('active'));
      subcatContents.forEach(c => c.classList.remove('active'));
      btn.classList.add('active');
      document.getElementById(`tab-${tabPrefix}-${btn.dataset.subcat}`).classList.add('active');
    };
  });
}

// Gender selection logic
const tabHer = document.getElementById('tab-her');
const tabHim = document.getElementById('tab-him');
const genderInputs = document.querySelectorAll('input[name="gender"]');

tabHer.style.display = 'none';
tabHim.style.display = 'none';

genderInputs.forEach(input => {
  input.addEventListener('change', function() {
    if (this.value === 'female') {
      tabHer.style.display = 'block';
      tabHim.style.display = 'none';
      setupSubcats('her');
      document.getElementById('service').value = '';
      document.getElementById('selected-service').textContent = '';
      document.querySelectorAll('#tab-her .service-list li').forEach(item => item.classList.remove('selected'));
    } else if (this.value === 'male') {
      tabHer.style.display = 'none';
      tabHim.style.display = 'block';
      setupSubcats('him');
      document.getElementById('service').value = '';
      document.getElementById('selected-service').textContent = '';
      document.querySelectorAll('#tab-him .service-list li').forEach(item => item.classList.remove('selected'));
    }
  });
});

document.querySelectorAll('.service-list li').forEach(li => {
  li.addEventListener('click', function() {
    document.querySelectorAll('.service-list li').forEach(item => item.classList.remove('selected'));
    li.classList.add('selected');
    document.getElementById('service').value = li.dataset.value;
    document.getElementById('selected-service').textContent = li.textContent;
  });
});